module.exports = __webpack_public_path__ + "img/product-icon2.e1326cea.png";